import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import Col from 'kepler/lib/components/Col';
import Row from 'kepler/lib/components/Row';
import ToolsSearch from './ToolsSearch';
import DefaultCategoriesList from './DefaultCategoriesList';
import Disclaimer from './AppDetailDisclaimer';
import getContent from '../lib/dictionaryFetcher';

/**
 * render all the categories for desktop or laptop screensize.
 * @param {*} props
 */
const DefaultCategoriesContent = props => {
  const {
    app,
    tools,
    toggleFavorite,
    setTool,
    setApp,
    search,
    recordClick,
    tracking,
    title,
    category,
    featured
  } = props;

  const user = get(app, 'context.user', {});

  const categoryName = get(category, 'name', '');
  let featuredItem = get(featured, categoryName, '');
  if (categoryName === 'discover') {
    const featuredItems = get(user, 'eligibility.otss', []);
    const { priority = [] } = get(category, 'categories', []).find(
      ({ type }) => type === 'featured'
    );
    featuredItem = priority.find(item => featuredItems.includes(item));
  }

  /**
   * render panel with cards.
   *
   * @param {string} title
   * @param {int} index
   * @param {object} category
   */

  return (
    <Row className="myapps-container">
      <Col className="myapps-wrapper">
        <ToolsSearch
          user={user}
          tools={tools}
          setTool={setTool}
          setApp={setApp}
          search={search}
          tracking={tracking}
          recordClick={recordClick}
          toggleFavorite={toggleFavorite}
        />
        <DefaultCategoriesList {...props} title={title} category={category} />
        <Disclaimer
          disclaimers={getContent(
            'merchanthub',
            `apps.${featuredItem}.featured.disclaimer`,
            []
          )}
        />
      </Col>
    </Row>
  );
};

DefaultCategoriesContent.propTypes = {
  app: PropTypes.object,
  toggleFavorite: PropTypes.func,
  tools: PropTypes.object,
  search: PropTypes.object,
  recordClick: PropTypes.func,
  setTool: PropTypes.func,
  setApp: PropTypes.func,
  tracking: PropTypes.object,
  title: PropTypes.string,
  category: PropTypes.object,
  featured: PropTypes.object
};

export default DefaultCategoriesContent;
